//react
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LoadingDialog } from '../dialogs';
import {corestyles} from '../../styles';
import { createItemList } from '../form';
import { formatJsonDataset } from '../renderers';
import { Box } from '@mui/material';

const s:any = {
  ...corestyles,
}

/**
 * -------------------------------------------------------------------
 * Inspector Panel
 * -------------------------------------------------------------------
 */
class InspectorPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  constructor(props: any) {
    super(props);
    this.state = {
      mode: props.mode,
      init: false,
      loading: false,
      fopen: false,
      childs: {},
    };
  }

  startLoading = () => this.setState({ loading: true });
  stopLoading = () => this.setState({ loading: false });

  render = () => {
    const {
      mode,
      sdata,
      record,
      formatters,
      onChange,
      classes,
      selected,
      reset,
      cvalue,
      formData,
      cuparams,
      ...others
    } = this.props;

    const { loading } = this.state;
    const extras = { selected, reset, cvalue, cuparams, others };

    const formitems = createItemList(mode, sdata, record, formatters, onChange, extras);
    console.log('inspector panel.items', formitems);
    console.log('Form data', formData);

    // ✅ Use the iti value from formData instead of from item props
    const itiValue = formData?.iti;

    // Determine which conditional item to show based on itiValue
    let conditionalItemId: string | null = null;
    if (itiValue === 1) conditionalItemId = 'usi';
    else if (itiValue === 2) conditionalItemId = 'nam';

    return (
      <Box sx={{...s.container}}>
        <Box component='form' id="requestform" sx={{...s.reqform}}>
          <LoadingDialog status={loading} start={this.startLoading} stop={this.stopLoading} />

          {formitems.map((item: any) => {
            // special rendering logic for 'exi'
            if (item.id === 'exi') {
              return (
                <Box key={item.id}>
                  <Box component='span'>
                    {item.dom.props.label} {formatJsonDataset(item.dom.props.value, record)}
                  </Box>
                </Box>
              );
            }

            // ✅ Conditional rendering based on formData.iti
            if ((item.id === 'usi' || item.id === 'nam') && item.id !== conditionalItemId) {
              return null;
            }

            return <Box key={item.id}>{item.dom}</Box>;
          })}
        </Box>
      </Box>
    );
  };
}

// InspectorPanel.propTypes = {
//   service: PropTypes.string.isRequired,
//   mode: PropTypes.oneOf(['add', 'edit', 'delete', 'view', 'close', 'manage', 'wizard']).isRequired,
//   sdata: PropTypes.object,
//   record: PropTypes.object,
//   onChange: PropTypes.func,
//   formatters: PropTypes.object,
//   formData: PropTypes.object,
// };

export default InspectorPanel;
